'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    terms: 'Você precisa aceitar os termos para que sua ação seja publicada.',
    sure: 'Tem certeza que deseja sair?',
    sure_text:
      'Caso queira realizar esse aceite mais tarde, consulte a página de MINHAS AÇÕES que essa ação estará salva, mas não publicada.',
    yes: 'Sim, sair da página',
    no: 'Cancelar',
  },
  en: {
    terms: 'You must accept the terms for your action to be published.',
    sure: 'Are you sure you want to quit?',
    sure_text: 'If you want to accept this later, check the MY ACTIONS page and this action will be saved, but not published.',
    yes: 'Yes, leave the page',
    no: 'Cancelar',
  },
  es: {
    terms: 'Debes aceptar los términos para que tu acción sea publicada.',
    sure: '¿Seguro que quieres salir?',
    sure_text: 'Si desea aceptar esto más tarde, consulte la página MIS ACCIONES y esta acción se guardará, pero no se publicará.',
    yes: 'Si, sal de la pagina',
    no: 'Cancel',
  },
};

const leaderTerms = {
  settings: {
    warnBeforeClose: true,
    $checkbox: $('#check-terms'),
  },

  unloadPage() {
    if (s.warnBeforeClose) {
      return 'Tem certeza?';
    }
  },

  dontWarn() {
    s.warnBeforeClose = false;

    setTimeout(function () {
      s.warnBeforeClose = true;
    }, 1000);
  },

  init() {
    window.onbeforeunload = _this.unloadPage;

    $('.js-form-terms').on('submit', function (e) {
      e.preventDefault();
      _this.dontWarn();

      if (s.$checkbox.is(':checked')) {
        this.submit();
      } else {
        Swal.fire(tr[lang].terms, '', 'error');
      }
    });

    $('a:not(.js-review)').on('click', function (e) {
      e.preventDefault();

      Swal.fire({
        title: tr[lang].sure,
        text: tr[lang].sure_text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5eb245',
        cancelButtonColor: '#d33',
        confirmButtonText: tr[lang].yes,
        cancelButtonText: tr[lang].no,
        reverseButtons: true,
      }).then(result => {
        _this.dontWarn();
        if (result.value) {
          window.location.href = e.currentTarget.href;
        }
        return false;
      });
    });

    $('.js-review').on('click', function () {
      _this.dontWarn();
    });
  },
};

const s = leaderTerms.settings,
  _this = leaderTerms;

export default _this;
